import AppSerializer from 'serializers/app';

class EventSerializer extends AppSerializer {
	constructor(store, props) {
		super(store, props);
	}

	get relationships() {
		return {
			schedule: { serialize: 'id' },
		}
	}

}

export default EventSerializer;